import { Icon } from "@iconify/react";
import { useLang } from "@/i18n";

const navColHrefs = [
  ["#services", "#services", "#services", "#services"],
  ["#about", "#about", "#about", "#about"],
  ["#contact", "#contact", "#contact", "mailto:sylvia@chinaascend.net"],
];

const socials = [
  { icon: "mdi:instagram", href: "https://www.instagram.com/ascend_marketingagency/", label: "Instagram" },
  { icon: "mdi:whatsapp", href: "https://wa.me/message/5OW3DGEVIU4UM1", label: "WhatsApp" },
];

export default function Footer() {
  const { t } = useLang();
  const navCols = t.footer.navCols.map((col, ci: number) => ({
    ...col,
    links: col.links.map((link, li: number) => ({ label: link, href: navColHrefs[ci][li] })),
  }));
  const scrollTo = (href: string) => {
    if (href.startsWith("mailto")) {
      window.location.href = href;
      return;
    }
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ background: "#050505", borderTop: "none" }}>
      {/* Top accent */}
      <div style={{ height: 1, background: "linear-gradient(90deg, transparent, rgba(244,68,12,0.35) 50%, transparent)" }} />
      <div className="max-w-7xl mx-auto footer-main-pad">

        {/* Top row */}
        <div className="footer-grid" style={{ marginBottom: "4rem", paddingBottom: "4rem", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          {/* Brand */}
          <div className="footer-brand-col">
            <button
              onClick={() => scrollTo("#hero")}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 0, marginBottom: "1.5rem", display: "block" }}
            >
              <img
              src="/images/ascend-logo-new.png"
              alt="Ascend"
              style={{ height: 30, width: "auto" }}
              />
            </button>
            <p style={{
              fontSize: "0.9rem",
              lineHeight: 1.85,
              color: "rgba(255,255,255,0.45)",
              fontWeight: 400,
              maxWidth: 260,
              marginBottom: "2rem",
            }}>
              {t.footer.tagline}
            </p>
            {/* Socials */}
            <div style={{ display: "flex", gap: "1rem" }}>
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  style={{
                    width: 34,
                    height: 34,
                    border: "1px solid rgba(255,255,255,0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "rgba(255,255,255,0.35)",
                    transition: "all 0.3s",
                    textDecoration: "none",
                  }}
                  onMouseEnter={e => {
                    const el = e.currentTarget as HTMLElement;
                    el.style.borderColor = "#f4440c";
                    el.style.color = "#f4440c";
                  }}
                  onMouseLeave={e => {
                    const el = e.currentTarget as HTMLElement;
                    el.style.borderColor = "rgba(255,255,255,0.1)";
                    el.style.color = "rgba(255,255,255,0.35)";
                  }}
                >
                  <Icon icon={s.icon} style={{ fontSize: 16 }} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav cols */}
          {navCols.map((col) => (
            <div key={col.title}>
              <div style={{ marginBottom: "1.25rem" }}>
                <div style={{ fontSize: "0.92rem", fontWeight: 600, color: "rgba(255,255,255,0.82)", marginBottom: "0.2rem" }}>{col.title}</div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
                {col.links.map((link) => (
                  <button
                    key={link.label}
                    onClick={() => scrollTo(link.href)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "rgba(255,255,255,0.45)",
                      fontSize: "0.88rem",
                      fontWeight: 400,
                      padding: 0,
                      textAlign: "left",
                      transition: "color 0.3s",
                      letterSpacing: "0.02em",
                    }}
                    onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = "rgba(255,255,255,0.7)"; }}
                    onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = "rgba(255,255,255,0.3)"; }}
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.28)", letterSpacing: "0.06em" }}>
            © 2024 Ascend Marketing Agency. All Rights Reserved.
          </span>
          <div style={{ display: "flex", gap: "2rem" }}>
            {t.footer.legal.map((item: string) => (
              <button
                key={item}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "rgba(255,255,255,0.15)",
                  fontSize: "0.62rem",
                  letterSpacing: "0.1em",
                  padding: 0,
                  transition: "color 0.3s",
                }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = "rgba(255,255,255,0.45)"; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = "rgba(255,255,255,0.15)"; }}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
